/**
 * Main application entry point - WordPress compatible
 * This file initializes the application and coordinates all modules
 * Fixed to prevent duplicate initialization
 */
(function (global) {
  "use strict";

  // Prevent duplicate initialization
  if (global.appInitialized) {
    console.log("Application already initialized, skipping...");
    return;
  }

  // Use our utility functions (should be loaded before this file)
  const onDocumentReady =
    global.onDocumentReady ||
    function (callback) {
      if (document.readyState !== "loading") {
        setTimeout(callback, 0);
      } else {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
      }
    };

  // Main application initialization
  const initApp = () => {
    // Prevent duplicate initialization
    if (global.appInitialized) {
      console.log("Application already initialized");
      return;
    }

    // Mark as initialized early
    global.appInitialized = true;

    console.log("Application initialized");

    // Add a global class to indicate JS is loaded
    document.documentElement.classList.add("js-loaded");

    // Check for jQuery availability
    if (typeof jQuery !== "undefined") {
      console.log("jQuery is available:", jQuery.fn.jquery);
    }

    // Check for constants availability
    if (global.Constants) {
      console.log("Constants loaded:", Object.keys(global.Constants));
    }

    // Trigger a custom event for other scripts to hook into
    if (typeof CustomEvent !== "undefined") {
      const appInitEvent = new CustomEvent("app:initialized", {
        detail: { timestamp: Date.now() },
      });
      document.dispatchEvent(appInitEvent);
    }

    // jQuery compatibility - trigger event for jQuery-dependent code
    if (typeof jQuery !== "undefined" && jQuery.fn.trigger) {
      jQuery(document).trigger("app:initialized");
    }
  };

  // Initialize when DOM is ready - ONLY use onDocumentReady, not both
  onDocumentReady(() => {
    if (!global.appInitialized) {
      initApp();
    }
  });

  // Make initialization function available globally
  global.initApp = initApp;

  // Expose app utilities
  global.App = global.App || {};
  global.App.init = initApp;
  global.App.version = "1.0.0";
})(typeof window !== "undefined" ? window : this);
